import {
  ServiceLevelShippingMarginOverTimeRequestSchema,
  ServiceLevelShippingMarginOverTimeResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getServiceLevelShippingMarginOverTime = {
  name: "getServiceLevelShippingMarginOverTime" as const,
  input: ServiceLevelShippingMarginOverTimeRequestSchema,
  output: ServiceLevelShippingMarginOverTimeResponseSchema,
};
